import { render, staticRenderFns } from "./Internalchat.vue?vue&type=template&id=452b223a&scoped=true"
import script from "./Internalchat.vue?vue&type=script&lang=js"
export * from "./Internalchat.vue?vue&type=script&lang=js"
import style0 from "./Internalchat.vue?vue&type=style&index=0&id=452b223a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b223a",
  null
  
)

export default component.exports